import { useBreakpoints, breakpointsTailwind } from "@vueuse/core"

export default function useResponsive() {
  //Keep vuetify breakpoints for drawer width

  const breakpoints = useBreakpoints(breakpointsTailwind)
  const smallerThanMd = breakpoints.smaller("md")

  return {
    smallerThanMd,
  }
}
